:root {
  --g-top-bar-height: 48px;
  --g-mobile-top: 59px;
  --g-mobile-bottom: 94px;
  --g-mobile-preview-max-height: 512px; }

._mobile-frame-opacity-layer_nssnm_7 {
  position: absolute;
  pointer-events: none; }
  ._mobile-frame-opacity-layer_nssnm_7:before, ._mobile-frame-opacity-layer_nssnm_7:after {
    content: '';
    position: absolute;
    top: var(--g-mobile-top);
    height: 100%;
    background-color: rgba(255, 255, 255, 0.6);
    width: calc((100% - 320px) / 2); }
  ._mobile-frame-opacity-layer_nssnm_7:before {
    left: 0; }
  ._mobile-frame-opacity-layer_nssnm_7:after {
    right: 0; }

._mobileWizard_nssnm_22 {
  position: absolute;
  width: 100%;
  height: 100%; }
  ._mobileWizard_nssnm_22 ._mobileWizardLeftHalf_nssnm_26 {
    position: relative;
    transition: transform 1.7s cubic-bezier(0.4, 0, 0.2, 1);
    transform: translateX(-100%);
    box-sizing: border-box;
    text-align: center;
    background: #fff;
    width: 50%;
    left: 0;
    top: 0;
    height: 100%;
    min-width: 640px; }
  ._mobileWizard_nssnm_22 ._mobileWizardTopBar_nssnm_38 {
    transition: opacity 1.7s ease-in-out;
    opacity: 0;
    width: 100%;
    height: 48px;
    position: absolute;
    top: 0;
    z-index: 1; }
    ._mobileWizard_nssnm_22 ._mobileWizardTopBar_nssnm_38 ._topBarLeftWixLogo_nssnm_46 {
      border-right: none;
      position: absolute;
      left: 23px;
      top: 15px; }
    ._mobileWizard_nssnm_22 ._mobileWizardTopBar_nssnm_38 ._mobileWizardTopBarSkip_nssnm_51 {
      position: absolute;
      font-size: 16px;
      top: 28px;
      right: 36px; }
  ._mobileWizard_nssnm_22._mobileWizardExpanded_nssnm_56 ._mobileWizardLeftHalf_nssnm_26 {
    transform: translateX(0); }
  ._mobileWizard_nssnm_22._mobileWizardExpanded_nssnm_56 ._mobileWizardTopBar_nssnm_38 {
    opacity: 1; }
  ._mobileWizard_nssnm_22 ._mobileWizardInner_nssnm_60 {
    top: calc( 50% - 247.5px - 36px);
    position: relative; }
    ._mobileWizard_nssnm_22 ._mobileWizardInner_nssnm_60::after {
      content: '';
      border-right: 1px solid #d3edff;
      position: absolute;
      width: 0;
      height: 608px;
      top: 0;
      right: 0; }
    ._mobileWizard_nssnm_22 ._mobileWizardInner_nssnm_60 ._currentStepContainer_nssnm_71 {
      min-height: 400px;
      max-width: 542px;
      margin: auto;
      width: 100%;
      box-sizing: border-box;
      padding: 12px 0; }
    ._mobileWizard_nssnm_22 ._mobileWizardInner_nssnm_60 ._mobileWizardActions_nssnm_78 {
      justify-content: center; }
      ._mobileWizard_nssnm_22 ._mobileWizardInner_nssnm_60 ._mobileWizardActions_nssnm_78 button:first-of-type {
        margin-left: 0; }
